import { Controller } from "stimulus"

export default class BooksController extends Controller {
  static get targets() {
    return ["book"]
  }

  connect() {
    this.booksCount = this.bookTargets.length

    // load covers and
    const booksInterval = setInterval(() => {
      this.bookTargets.forEach((b) => {
        const book = b.querySelector(".book")
        const coverImg = book.querySelector(".cover img")
        const sideImg = book.querySelector(".side img")
        const details = b.querySelector(".details")
        if (coverImg.complete && sideImg.complete && !book.classList.contains("show")) {
          book.querySelector(".side").style.left = `${-sideImg.offsetWidth}px`
          book.style.left = `calc(50% - ${Math.round(coverImg.offsetWidth / 2)}px)`
          book.style.top = `calc(50% - ${Math.round(coverImg.offsetHeight / 2)}px)`

          details.style.width = `${coverImg.offsetWidth}px`
          details.style.paddingLeft = `${Math.round(coverImg.offsetWidth * 0.15) + 16}px`

          book.classList.add("show")
          this.booksCount -= 1
        }
      })

      if (this.booksCount === 0) {
        clearInterval(booksInterval)
      }
    }, 100)
  }
}
